import { createLazyImports } from '../../global/lazyLoad/lazyLoadUtils';

const componentPaths = {
    LazyDstFilter: () => import(/* webpackChunkName: 'cmp-DstFilter' */ '../Dstfilter/DstFilter'),
    LazyDstTrainerCard: () => import(/* webpackChunkName: 'cmp-DstTrainerCard' */ '../DstTrainerCard')
};

const LazyLoadDstImports = createLazyImports(componentPaths);

export const { LazyDstFilter, LazyDstTrainerCard } = LazyLoadDstImports;